import { Button, Result, Space } from 'antd';
import { Link, useNavigate, useRouteError } from 'react-router-dom';
import { useSession } from '../auth/session';

export function NotFoundPage() {
  return (
    <Result
      status="404"
      title="Không tìm thấy trang"
      subTitle="Đường dẫn không tồn tại hoặc đã đổi."
      extra={
        <Link to="/">
          <Button type="primary">Về bảng điều khiển</Button>
        </Link>
      }
    />
  );
}

/** Đăng nhập được nhưng vai trò không thuộc Admin Web — cashier và host dùng Staff App (BR-801). */
export function ForbiddenPage() {
  const signOut = useSession((state) => state.signOut);
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="Tài khoản không dùng được Admin Web"
      subTitle="Vai trò thu ngân và lễ tân làm việc trên Staff App. Cần quyền quản lý chi nhánh trở lên."
      extra={
        <Space wrap>
          <Button size="large" onClick={() => navigate('/ho-tro')}>
            Trung tâm hỗ trợ
          </Button>
          <Button type="primary" size="large" onClick={signOut}>
            Đăng nhập tài khoản khác
          </Button>
        </Space>
      }
    />
  );
}

/** Bắt lỗi render bất ngờ để không trắng màn hình. */
export function RouteErrorPage() {
  const error = useRouteError();
  const detail = error instanceof Error ? error.message : String(error ?? '');

  return (
    <Result
      status="error"
      title="Giao diện gặp lỗi"
      subTitle="Tải lại trang. Nếu vẫn lỗi, gửi thông tin bên dưới cho kỹ thuật."
      extra={
        <Button type="primary" onClick={() => window.location.reload()}>
          Tải lại
        </Button>
      }
    >
      {detail && (
        <pre style={{ fontSize: 11, whiteSpace: 'pre-wrap', margin: 0, opacity: 0.7 }}>{detail}</pre>
      )}
    </Result>
  );
}
